<form [formGroup]="formGroup()" (ngSubmit)="onSubmit()">
  <div class="mb-3">
    <mat-card appearance="outlined">
      <mat-card-content>
        <div class="row">
          @for (filterName of filterNames(); track filterName) {
            <div class="col-lg-2 col-md-6 col-sm-12 d-grid">
              <mat-dropdown
                [formControl]="controls()[filterName]"
                [configurationInput]="{
                  text: 'filterCard.' + filterName | translate,
                  singleSelection: true,
                  hasMatError: false,
                  enableSearchFilter: searchableFilters | arrayIncludes: filterName,
                }"
                [options]="(optionsList[filterName].data | async) ?? []"
                (search)="search.set({ target: filterName, value: $event })"
              ></mat-dropdown>
            </div>
          }
        </div>
      </mat-card-content>
    </mat-card>

    <div class="my-3" *ngIf="showApply | async">
      <mat-card appearance="outlined">
        <mat-card-content>
          <button mat-flat-button type="submit">{{ 'button.update' | translate }}</button>
          <span class="p-xl-1">{{ 'system.message.filterCardUpdateText' | translate }}</span>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</form>
